const tabs = () => {
  const tabsContainers = document.querySelectorAll('.tabs-container');
  if (!tabsContainers.length) {
    return;
  }
  const tabClickHandler = (event, tabsContainer) => {
    const clickedTab = event.currentTarget;
    if (clickedTab.classList.contains('active')) {
      return;
    }

    const tabList = tabsContainer.querySelectorAll('.tabs-tab-list-item');
    const tabContentList = tabsContainer.querySelectorAll('.tabs-tab-content-item');
    const tabIndex = clickedTab.dataset.tab;

    tabList.forEach(tab => {
      const index = tab.dataset.tab;
      if (index === tabIndex) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });

    tabContentList.forEach(content => {
      content.classList.remove('active');
    });

    let activeContent = null;
    tabContentList.forEach(content => {
      const index = content.dataset.content;
      if (index === tabIndex) {
        content.classList.add('active');
        activeContent = content;
      }
    });

    if(activeContent) {
      const customEvent = new CustomEvent("tabClicked", {detail: {activeContent, type: tabsContainer.dataset?.type}});
      tabsContainer.dispatchEvent(customEvent);
    }
  };

  const dropdownClickHandler = (event, tabsContainer) => {
    const clickedItem = event.currentTarget;
    let activeContent = null;

    tabsContainer.querySelector('.tabs-dropdownmenu').classList.remove('expanded');
    if (clickedItem.classList.contains('active')) {
      return;
    }

    const itemList = tabsContainer.querySelectorAll('.tabs-dropdownmenu-list-item');
    const desktopItemsList = tabsContainer.querySelectorAll('.tabs-tab-list-item');
    const tabContentList = tabsContainer.querySelectorAll('.tabs-tab-content-item');
    const tabIndex = clickedItem.dataset.tab;

    itemList.forEach((tab, idx) => {
      const index = tab.dataset.tab;
      if (index === tabIndex) {
        tab.classList.add('active');
        desktopItemsList[idx]?.classList.add('active');
        tabsContainer.querySelector('.tabs-dropdownmenu-selected').innerHTML = tab.textContent;
      } else {
        tab.classList.remove('active');
        desktopItemsList[idx]?.classList.remove('active');
      }
    });

    tabContentList.forEach(content => {
      content.classList.remove('active');
    });

    tabContentList.forEach(content => {
      const index = content.dataset.content;
      if (index === tabIndex) {
        content.classList.add('active');
        activeContent = content;
      }
    });

    if(activeContent) {
      const customEvent = new CustomEvent("tabClicked", {detail: {activeContent, type: tabsContainer.dataset?.type}});
      tabsContainer.dispatchEvent(customEvent);
    }
  };

  const dropdownSelectedClickHandler = (event, tabsContainer) => {
    const dropdown = tabsContainer.querySelector('.tabs-dropdownmenu');
    if (dropdown?.classList.contains('expanded')) {
      dropdown.classList.remove('expanded');
      return;
    }
    dropdown?.classList.add('expanded');
  };

  tabsContainers.forEach(tabsContainer => {
    const tabList = tabsContainer.querySelectorAll('.tabs-tab-list-item');
    const mobileMenu = tabsContainer.dataset?.type === "insights";
    let mobileMenuContainer, mobileMenuList, selected;

    if (mobileMenu) {
      mobileMenuContainer = document.createElement('div');
      selected = document.createElement('div');
      mobileMenuList = document.createElement('div');
      mobileMenuList.classList.add('tabs-dropdownmenu-list');
      mobileMenuContainer.classList.add('tabs-dropdownmenu');
      selected.classList.add('tabs-dropdownmenu-selected');
    }

    tabList.forEach(tab => {
      let activeContent = null;

      if (!tab.classList.contains('event-attached')) {
        tab.addEventListener('click', event => tabClickHandler(event, tabsContainer));
        tab.classList.add('event-attached');

        if (mobileMenu) {
          const mobileMenuListElement = document.createElement('div');
          mobileMenuListElement.classList.add('tabs-dropdownmenu-list-item');
          mobileMenuListElement.dataset.tab = tab.dataset.tab;
          mobileMenuListElement.innerHTML = tab.textContent;
          mobileMenuListElement.addEventListener('click', event => dropdownClickHandler(event, tabsContainer));

          if (tab.classList.contains('active')) {
            selected.innerHTML = tab.textContent;
            mobileMenuListElement.classList.add('active');
          }

          mobileMenuList.appendChild(mobileMenuListElement);
        }
      }

      if (tab.classList.contains('active')) {
        activeContent = tabsContainer.querySelector(`[data-content="${tab.dataset.tab}"]`);
      }

      if(activeContent) {
        const customEvent = new CustomEvent("tabLoaded", {detail: {activeContent, type: tabsContainer.dataset?.type}});
        tabsContainer.dispatchEvent(customEvent);
      }
    });

    if (mobileMenu) {
      selected.addEventListener('click', event => dropdownSelectedClickHandler(event, tabsContainer));

      mobileMenuContainer.appendChild(selected);
      mobileMenuContainer.appendChild(mobileMenuList);
      tabsContainer.prepend(mobileMenuContainer);
    }
  });
};

export default tabs;
